export const statCardSchema = {
    componentId: 'StatCard',
    scalarSlots: [
        { key: 'value', label: 'Value', type: 'text' },
        { key: 'label', label: 'Label', type: 'text' },
        { key: 'caption', label: 'Caption', type: 'textarea' },
    ],
    mediaSlots: [
        { key: 'icon', label: 'Icon', targets: [{ width: 96, height: 96, aspectRatio: '1:1' }] },
    ],
};
//# sourceMappingURL=stat-card.js.map